import React, { useContext, useEffect, useState } from 'react'

import { WappContext, withWapp } from 'wapplr-react/dist/common/Wapp'
import getUtils from 'wapplr-react/dist/common/Wapp/getUtils'

import clsx from 'clsx'

import VerticalMoreIcon from 'karrierhub-ui/dist/common/src/svg/VerticalMoreIcon'
import BackIcon from 'karrierhub-ui/dist/common/src/svg/BackIcon'

import MenuContext from 'karrierhub-ui/dist/common/src/components/Menu/context'
import Menu from 'karrierhub-ui/dist/common/src/components/Menu'
import Typography from 'karrierhub-ui/dist/common/src/components/Typography'
import Paper from 'karrierhub-ui/dist/common/src/components/Paper'

import AppContext from '../App/context'
import AvatarMe from '../Avatar/me'
import Avatar from '../Avatar'
import NotFound from '../NotFound'

import getStatus from '../../utils/getStatus'

import IconButton from '../IconButton'

import style from './style.css'

import AccountContext from './context'
import { getPageName as defaultGetPageName, getTitle } from './utils'
import getMenu from './menu'

import Router from './Router'

import { accountPages } from './accountPages'

function Account(props) {

    const menuContext = useContext(MenuContext)

    const appContext = useContext(AppContext)
    const context = useContext(WappContext)

    const {
        className,
        parentRoute = appContext.routes.accountRoute,
        size = 'large',
        name = 'user',
        getPageName = defaultGetPageName,
        PaperContainer = Paper,
        disableAvatar,
        disableBackButton,
        disableMenu,
        disableTitle,
        pages = accountPages,
        type = 'detailed'
    } = props

    const utils = getUtils(context)
    const { subscribe } = props

    const { wapp, res, req } = context

    wapp.styles.use(style)

    const [user, setUser] = useState(typeof props.user !== 'undefined' ? props.user : utils.getRequestUser())

    const editor = utils.getRequestUser()

    const isAuthor = editor?._id === user?._id && editor?._id

    const AvatarComponent = isAuthor ? AvatarMe : Avatar

    function onUserChange(user) {
        setUser((user?._id) ? user : null)
    }

    useEffect(function() {
        if (typeof props.user == 'undefined') {
            const unsub = subscribe.userChange(onUserChange)
            return function useUnsubscribe() {
                unsub()
            }
        }
    }, [subscribe, user])

    useEffect(() => {
        if (req.wappRequest.query.response) {
            async function asyncFunction() {
                await new Promise((resolve) => setTimeout(resolve, 1))
                await appContext.template.current?.actions?.setSnackMessage(req.wappRequest.query.response, 6000, 'error')
            }

            // noinspection JSIgnoredPromiseFromCall
            asyncFunction()
        }
    }, [])

    const page = props.page || res.wappResponse.route.params.page

    const pageName = getPageName({ user, page })

    if (!pageName && res.wappResponse.statusCode === 200) {
        res.wappResponse.status(404)
    }

    const avatarClick = () => {
        wapp.client.history.push({ pathname: appContext.routes.userRoute + '/' + user._id, search: '', hash: '' })
    }

    const backClick = () => {
        wapp.client.history.push({
            pathname: (pageName === 'settings') ? appContext.routes.userRoute + '/' + user._id : parentRoute + '/settings',
            search: '',
            hash: ''
        })
    }

    const statusManager = wapp.getTargetObject().postTypes.findPostType({ name: name }).statusManager

    if ((pageName === 'settings' && user?._id)) {

        const history = res.wappResponse.store.getState('app.history') || []
        const lastItem = history[history.length - 1]

        if (
            lastItem.referrer?.startsWith(appContext.routes.accountRoute + '/login') ||
            lastItem.referrer?.startsWith(appContext.routes.accountRoute + '/signup') ||
            lastItem.referrer?.startsWith(appContext.routes.accountRoute + '/resetpassword')
        ) {
            return null
        }
    }

    return (
        <>
            {(pageName) ?
                <div className={
                    clsx(
                        style.account,
                        className,
                        { [style[pageName]]: style[pageName] }
                    )
                }>
                    <MenuContext.Provider value={{
                        ...menuContext,
                        parentRoute,
                        getPropsForMenuItemProps: () => {
                            return {
                                user,
                                page,
                                req
                            }
                        }
                    }}>
                        <PaperContainer
                            color={'paper1'}
                            className={clsx(
                                style.container,
                                { [style.paperVisible]: PaperContainer === Paper }
                            )}
                            container-type={pageName === 'signup' ? 'root-page' : 'root-login'}
                            size={size}
                        >
                            {
                                (user?._id && !disableAvatar) ?
                                    <div className={style.userLayout}>
                                        <div className={style.userBox}>
                                            <div className={style.avatar}>
                                                <AvatarComponent
                                                    box={true}
                                                    color={'secondary'}
                                                    user={user}
                                                    onClick={avatarClick}
                                                    secondaryText={
                                                        getStatus({
                                                            user,
                                                            post: user,
                                                            appContext,
                                                            statusManager,
                                                            name
                                                        })
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    : null
                            }
                            <Paper
                                size={'appbar'}
                                borderRadius={0}
                                elevation={0}
                                className={style.appBar}
                            >
                                {(pageName !== 'logout') ?
                                    <div>
                                        {(user?._id && !disableBackButton) ?
                                            <div>
                                                <IconButton
                                                    size={size}
                                                    onClick={(pageName !== 'settings') ? backClick : avatarClick}
                                                    tip={
                                                        (pageName !== 'settings') ? appContext.menus.accountSettingsMenu : appContext.menus.dashboardMenu
                                                    }
                                                >
                                                    <BackIcon />
                                                </IconButton>
                                            </div>
                                            :
                                            null
                                        }
                                        {!disableTitle ?
                                            <div className={style.titleContainer}>
                                                <div className={style.title}>
                                                    <Typography variant={'h4'}>
                                                        {getTitle({
                                                            user,
                                                            page: res.wappResponse.route.params.page,
                                                            titles: appContext.titles
                                                        })}
                                                    </Typography>
                                                </div>
                                            </div> : null
                                        }
                                        {(pageName !== 'settings' && !disableMenu) ?
                                            <div>
                                                <Menu
                                                    PopoverProps={{
                                                        AnchorComponent: IconButton,
                                                        AnchorComponentProps: {
                                                            children: <VerticalMoreIcon />,
                                                            tip: user?._id ? appContext.menus.accountSettingsMenu : appContext.menus.loginMoreMenu,
                                                            size
                                                        }
                                                    }}
                                                    menu={getMenu({ appContext, type })}
                                                    MenuItemProps={{
                                                        size
                                                    }}
                                                />
                                            </div>
                                            :
                                            null
                                        }
                                    </div>
                                    :
                                    null
                                }
                            </Paper>
                            <AccountContext.Provider
                                value={{ user, parentRoute, name, page, statusManager, type, ...appContext.account }}>
                                <div className={style.content}>
                                    <Router page={page} router={getPageName} pages={pages} size={size} />
                                </div>
                            </AccountContext.Provider>
                        </PaperContainer>
                    </MenuContext.Provider>
                </div>
                :
                <NotFound />
            }
        </>
    )
}

export default withWapp(Account)
